import { store } from "store/store";
import { appSetLoading, appSetSendingRequest } from "store/actions/appAction";

import { errorDispatcher } from "helpers";
import axios from "../axios/axios";
import Axios from "axios";

export const createCookieInHour = (cookieName: string, cookieValue: string, hourToExpire: number) => {
    let date = new Date();
    date.setTime(date.getTime() + (hourToExpire * 60 * 60 * 1000));
    document.cookie = cookieName + " = " + cookieValue + "; expires = " + date.toDateString() + "; path = /"
}
export const dicHasval = (dic: object) => {
    if (!Array.isArray(dic) && dic !== null) {
      return Object.keys(dic).length > 0
    } else {
      return false
    }
  }
export const getCookie = (Name: string,): { val: string, valid: boolean } => {
    const cookies = document.cookie.split(';');
    const coockie = cookies.find(x => x.includes(`${Name}=`))
    if (coockie) {
        const result = coockie.split("=")
        if (result[1] !== "") {
            return { val: result[1], valid: true }
        }
        else {
            return { val: "", valid: false }
        }
    }
    return { val: "", valid: false }
}
export const checkUserAccess = (args: { checkUserAction: string, checkBussinesAccess?: string }) => {
    const { checkUserAction, checkBussinesAccess } = args
    let hasBussinesAccess = typeof checkBussinesAccess === "string"
    let isBusinessAccess = undefined
    if (hasBussinesAccess) {
        const business = store.getState().businessReducer.business
        const businessAccess = business?.user?.businessAccess
        if (businessAccess && checkBussinesAccess) {
            isBusinessAccess = businessAccess[checkBussinesAccess]
        }

    }
    if ((checkUserAction === "" || checkUserAction === undefined) && !hasBussinesAccess) return false
    if (hasBussinesAccess) return isBusinessAccess
    const business = store.getState().businessReducer.business
    const userAccesses = business?.user?.User_Accesses
    if (!userAccesses) return false
    const arrActions = checkUserAction.split(',')
    const hasAccesses = arrActions.map(y => {
        const hasAccess = userAccesses.some((x: any) => { return x.en_title.toLowerCase().trim() === y.toLowerCase().trim() })
        return hasAccess

    })
    if (hasBussinesAccess && typeof isBusinessAccess === "boolean") {
        return hasAccesses.includes(true) && isBusinessAccess
    }
    return hasAccesses.includes(true)
    // const { checkUserAction } = args
    // if (checkUserAction === "" || checkUserAccess === undefined) return false
    // const business = store.getState().businessReducer.business
    // const reduxStore = store.getState()
    // const userRole = business?.business?.userRole;
    // const roles = reduxStore.roleReducer?.roles;
    // const currentRole = roles.find((item: any) => item?.fa_title === userRole);
    // const user = business?.user;
    // let userAccesses: any[] = [];
    // if (user && user.User_Accesses) {
    //     userAccesses = user.User_Accesses.map(({ AccessId }: { AccessId: any }) => AccessId);
    // }
    // if (currentRole) {
    //     const accesses = currentRole?.Accesses;
    //     const userAccessesArray = accesses?.filter((af: any) => userAccesses.includes(af.id));
    //     const permissions: string[] = userAccessesArray
    //         // @ts-ignore
    //         ?.map(({ en_title }) => en_title) || []

    //     const hasAccess = permissions.some(x => checkUserAction.toLowerCase().includes(x.toLowerCase()))
    //     return hasAccess
    // }

    // return false

}
export const sendToPos = async (args: { posIp: string, posPort: string, amount: number, transId: { id: number, index: number } }) => {

    const { amount, posIp, posPort, transId } = args
    const dispatch = store.dispatch
    const token = store.getState().businessReducer?.business?.token;
    const posAxios = Axios.create({
        baseURL: `http://localhost:${posPort}`,
        timeout: 3000000,
        headers: {
            "Content-Type": "application/json",
        },
    });
    dispatch(appSetSendingRequest(true));
    const res = await posAxios.post("/bpmpospc/service", {
        "ServiceCode": '1',
        "Amount": amount,
        "PayerId": "108",
        "PcID": '1234'
    }).catch(err => {

    }).finally(() => {
    })
    const params = { ...res?.data, transactionItemId: transId.id }
    const apiResInfo = await axios
        .post(`pos/pcToPos`, params, {
            headers: { Authorization: `Bearer ${token}` },
        })
        .catch((error) => {
            errorDispatcher(error, dispatch)
        })
        .finally(() => {
            dispatch(appSetSendingRequest(false));
        })
    return apiResInfo

}
export const postApi = async (args: { url: string, params: any }) => {
    const { params, url } = args
    const token = store.getState().businessReducer?.business?.token;
    const dispatch = store.dispatch
    dispatch(appSetLoading(true));
    const result = await axios
        .post(`/${url}`, params, {
            headers: { Authorization: `Bearer ${token}` },
        })
    dispatch(appSetLoading(false));
    if (result.status === 200)
        return result
    else {
        errorDispatcher(result.data, dispatch);
    }

}
// const post = async (args: { actionName: string, formData?: FormData, params?: object, timeOut?: number, headers?: any, responseType?: ResponseType, doNotUseAppSettingUrl?: boolean }) => {
//     const { actionName, formData, params, headers, timeOut, responseType, doNotUseAppSettingUrl } = args
//     const waitTime = timeOut ? timeOut * 1000 : 120000
//     const param = formData ? formData : Object.assign({}, params)
//     const getAppSetting = await getAppSettingInfo("AppSetting")
//     const apiUrl = `${doNotUseAppSettingUrl ? '' : getAppSetting.ApiUrl + '/'}${actionName}`

//     const token = getCookie("_autt")
//     if (!token.valid) {
//         refreshToken()
//     }
//     const header = { Authorization: `Bearer ${token.val}`, ...headers }
//     const result = await axios.post(apiUrl, param, { timeout: waitTime, headers: { ...header }, responseType })
//     if (result.data && result.data.Debugger && result.data.Debugger.length > 0 && result.data.Debugger[0]["Key"] === undefined) {
//         const rows: Array<IDebugger> = result.data.Debugger
//         for (const index in rows) {
//             rows[index]["Key"] = index
//         }
//         changeDebuggerData(rows)
//     }
//     return result
// }
export const getPersianMotnh = (month: number) => {
    const persianMonths = [
        "فروردین",
        "اردیبهشت",
        "خرداد",
        "تیر",
        "مرداد",
        "شهریور",
        "مهر",
        "آبان",
        "آذر",
        "دی",
        "بهمن",
        "اسفند",
    ];
    return persianMonths[month - 1];
}
export const getApi = async (args: { url: string, queryParams?: string }) => {
    const { queryParams, url } = args
    const token = store.getState().businessReducer?.business?.token;
    const dispatch = store.dispatch
    dispatch(appSetLoading(true));
    const result = await axios
        (`/${url}`, {
            headers: { Authorization: `Bearer ${token}` },
        })
    dispatch(appSetLoading(false));
    if (result.status === 200)
        return result
    else {

        errorDispatcher(result.data, dispatch);
        return result
    }

}

